module.exports = ".img-section img{\r\n    max-height:190px;\r\n    min-height:190px;\r\n}"